import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
declare var $: any;

@Component({
  selector: 'app-city-bd',
  templateUrl: './city-bd.component.html',
  styleUrls: ['./city-bd.component.css']
})
export class CityBdComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; usersList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; myrole: string;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circles = []; circle = '';
  search: string; currentUserId: any; circles_copy = []; status = ''
  booleanValue: any = false;
  constructor(private userapi: UserService, private sharedapi: SharedService, public leadapi: LeadsService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getcircle();
    this.sharedapi.getRole()
      .subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.currentUserId = localStorage.getItem('loginuserId');
  }

  setSearchValue() {
    $("#circleSearch").val('');
    $("#circleSearch").focus();
    this.circles = this.circles_copy;
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    }
  }

  ngAfterViewInit() {
    this.loadUsersList(0, this.perpage);
  }

  async loadUsersList(pageIndex, perpage) {
    this.usersList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&circle=' + this.circle + '&status=' + this.status;
    this.loading = true; this.loaded = false;
    this.userapi.getCityBdList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.usersList = data.data;
      } else {
        this.usersList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  getCircleName(circleData) {
    var splittedStringArray = circleData.split(",");
    let circleNames = '';
    splittedStringArray.forEach(element => {
      circleNames += '<span class="circleNamestyle">' + element + '</span>';
    });
    return circleNames;
  }
  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadUsersList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadUsersList(event.pageIndex, event.pageSize);
  }


  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


}
